<template>
    <div class="table_wrap">
        <div class="pagnation_wrap home-pagebar" v-if="paginationData.total > 0">
            <div class="inline-block" >
                <el-button class="pagebar-button" icon="el-icon-arrow-left" :disabled="page === 1"
                           @click="changePage('page', page - 1)"></el-button>
                <el-pagination
                    :page-size="paginationData.size"
                    :current-page.sync="page"
                    :pager-count="11"
                    :total="paginationData.total"
                    @current-change="changePage('page', page)"
                    class="bottom-pagebar"
                    layout="pager"
                    background>
                </el-pagination>
                <el-button class="pagebar-button" icon="el-icon-arrow-right" :disabled="page === returnLastPage()"
                           @click="changePage('page', page + 1)"></el-button>
            </div>
        </div>

        <!-- <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12">
                </el-col>
                <el-col :span="12" class="text_right">
                    <el-select
                        v-model="pageRow"
                        @change="setPageRow()"
                    >
                        <el-option
                            v-for="row in pageRows"
                            :key="row"
                            :label="`${row}개 씩보기`"
                            :value="row"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "PaginationDefaultLayout",
    mixins: [],
    components: {},
    inject: ['setPage', 'setSort'],
    props: {
        paginationData: {
            type: Object,
            default: {
                total: 0,
                page: 0,
                size: 0,
            }
        },
    },
    data() {
        return {
            page: 1,
            size: 10,
            pageRow: 10,
            pageRows: [10, 30, 50],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.page = this.paginationData.page;
        this.pageRow = this.paginationData.size;
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        changePage(key, value) {
            this.setPage(key, value);
        },
        returnLastPage() {
            return Math.ceil(this.paginationData.total / this.paginationData.size);
        },
        setPageRow() {
            this.setPage('size', this.pageRow)
        },
    },
    watch: {
        'paginationData.page': {
            deep: true,
            handler: function (val, oldVal) {
                this.page = this.paginationData.page;
            }
        },
        'paginationData.size': {
            deep: true,
            handler: function (val, oldVal) {
                this.pageRow = this.paginationData.size;
            }
        }
    },
}
</script>

<style scoped>

</style>
